/* eslint-disable react/no-unescaped-entities */
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import 'aos/dist/aos.css'
import 'aos/dist/aos.css'

import AOS from 'aos'
import Link from 'next/link'
import { useEffect } from 'react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import SolutionBlock from '@/components/careers/SolutionBlock'
import Testimonials from '@/components/careers/Testimonials'
import VideoModal from '@/components/careers/VideoModal'
import DotsCollection from '@/components/dotCollection'
import Footer from '@/components/footer'
import Header from '@/components/navigation'
import Picture from '@/components/picture'
import Slider from '@/components/slider'
import LinkedinGreyIcon from '@/components/svg/LinkedinGrey'
import RightIcon from '@/components/svg/Right'
import TwitterIcon from '@/components/svg/Twitter'
import {
  aboutDehaat,
  dehaatLifeImages,
  dehaatNumbers,
  founders,
  solutionsList,
  workCultureImages,
  workingBenefits,
} from '@/constants/careers'

const headingStyles =
  'font-semibold sm:font-bold text-[28px] sm:text-[32px] lg:text-[48px] leading-[40px] sm:leading-[48px] lg:leading-[60px] text-neutral-100'
const paraStyles = 'text-neutral-80 sm:text-lg leading-[28px]'

export async function getStaticProps() {
  return {
    props: {
      title: 'Dehaat - Current Openings',
      description:
        'DeHaat is the fastest growing AgTech startup in India and the only full stack agri platform in India.',
    },
  }
}

const CareersPage = () => {
  useEffect(() => {
    AOS.init({ delay: 100, easing: 'ease-in-sine' })
    AOS.refresh()
  }, [])

  return (
    <>
      <main className="m-auto font-natosans overflow-hidden">
        <Header className="bg-[#F3FFF8] -mt-4 lg:mt-0 lg:px-14" />

        <section className="bg-[#F3FFF8] flex items-center lg:justify-center flex-wrap lg:flex-nowrap p-4 sm:p-6 sm:pb-8 lg:pb-12">
          <div className="lg:mr-12 sm:max-w-[488px] lg:max-w-md xl:max-w-xl">
            <h1
              data-aos="fade-up"
              data-aos-delat="500"
              className="font-semibold sm:font-bold text-[28px] sm:text-[40px] lg:text-5xl leading-[40px] sm:leading-[52px] lg:leading-[60px] text-neutral-100"
            >
              Cultivate your potential with{' '}
              <span className="text-primary-100">DeHaat&apos;s</span> career
              opportunities.
            </h1>
            <p
              data-aos="fade-up"
              className="mt-4 lg:mt-6 text-neutral-80 sm:text-lg leading-[28px] sm:leading-[32px] lg:w-[90%]"
            >
              Align with India’s leading agri-tech firm in formulating the next
              tech-enabled agri-revolution. Where your work generates real value
              and makes you grow exponentially.
            </p>
          </div>
          <div className="mt-[18px] sm:mt-12 px-2 sm:px-[60px] lg:px-0 lg:mt-0 flex sm:gap-[54px] lg:gap-0 min-h-[218px] sm:min-h-[374px] lg:min-h-[512px]">
            <div className="flex flex-col items-center justify-between">
              <div data-aos="zoom-in-up" className="relative">
                <Picture
                  image="/assets/images/careers/landing-image1"
                  imageAlt="img"
                  imageStyle="aspect-square w-[124px] sm:w-[193px] lg:w-[240px] rounded-full z-10"
                />
                <div className="absolute bottom-0 right-3 sm:right-0 lg:right-4 w-[10px] sm:w-4 aspect-square rounded-full bg-primary-100" />
              </div>
              <div className="relative left-4 md:left-16">
                <Picture
                  image="/assets/images/careers/landing-image3"
                  imageAlt="img"
                  imageStyle="aspect-sqaure w-[66px] sm:w-[122px] lg:w-[184px] rounded-full z-10 relative"
                />
                <DotsCollection
                  rows={11}
                  columns={8}
                  mainContainerStyle="absolute bottom-5 sm:bottom-[56px] lg:bottom-[110px] -left-4 md:-left-8 lg:-left-4"
                  dotsStyle="h-[2px] w-[2px] md:w-1 md:h-1 bg-[#D9D9D9]"
                />
                <div className="absolute bottom-0 -left-1 sm:-left-3 w-[29px] sm:w-[53px] lg:w-20 aspect-square rounded-full bg-secondary-two-110" />
              </div>
            </div>
            <div data-aos="zoom-in-up" className="relative ml-4">
              <Picture
                image="/assets/images/careers/landing-image2"
                imageAlt="img"
                imageStyle="apect-square w-[162px] sm:w-[300px] lg:w-[380px] rounded-full z-10 relative lg:mt-8"
              />
              <div className="absolute bottom-10 left-0 w-[124px] sm:w-[228px] lg:2-[280px] aspect-square lg:left-20 lg:bottom-[75px] rounded-full bg-secondary-one-120" />
              <div className="absolute bottom-1 right-3/4 w-[13px] sm:w-6 aspect-square lg:right-4 lg:w-6 lg:h-6 rounded-full bg-secondary-two-110 lg:bottom-20" />
            </div>
          </div>
        </section>

        <section className="mt-10 sm:mt-[60px] lg:mt-[140px] flex items-center sm:items-start sm:flex-row flex-col-reverse lg:justify-center sm:justify-evenly px-4">
          <div
            data-aos="zoom-in"
            data-aos-delay="300"
            className="relative mt-12 sm:mt-4"
          >
            <VideoModal
              thumbnailUrl="/assets/images/careers/aboutDehaat.webp"
              fromYoutube
              videoLink="https://www.youtube.com/embed/OnojN3he-Xo"
              imageStyles="h-[236px] sm:h-[226px] lg:h-[450px] w-[265px] sm:w-[254px] lg:w-[505px] sm:rounded-[40px] lg:rounded-[60px]"
            />
            <DotsCollection
              rows={7}
              columns={7}
              mainContainerStyle="absolute -top-6 sm:-top-8 -left-2"
              dotsStyle="h-[2px] w-[2px] md:w-1 md:h-1 bg-primary-100 -z-10"
            />
            <div className="absolute -right-8 lg:-right-[65px] -top-6 lg:-top-11 h-[85%] w-[60%] rounded-[30px] sm:rounded-[50px] lg:rounded-[80px] bg-primary-100 -z-10" />
          </div>
          <div
            className="lg:max-w-xl max-w-sm sm:ml-8 lg:ml-[140px]"
            data-aos="fade-up"
          >
            <h1 className={`lg:font-bold ${headingStyles}`}>About DeHaat</h1>
            <p
              className="mt-4 sm:mt-2 lg:mt-4 lg:mt-6 leading-[28px] lg:leading-[32px] lg:text-lg text-neutral-80"
              data-aos="fade-up"
            >
              We are the fastest-growing Agri-Tech start-up providing end-to-end
              solutions and services to the farmers and the agriculture
              community in India. Associated with 1.8+ million farmers, in 11
              states and 503+ FPOs.
            </p>
            <div className="mt-1 sm:mt-1 lg:mt-4" data-aos="fade-up">
              {aboutDehaat.map((title) => (
                <div
                  key={title}
                  className="flex items-center gap-4 mt-5 lg:mt-4 sm:mt-3"
                >
                  <div className="bg-primary-10 h-8 w-8 rounded-full flex justify-center items-center">
                    <RightIcon />
                  </div>
                  <p className="text-neutral-90 lg:text-lg lg:leading-[32px]">
                    {title}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="md:mt-44 mt-10 flex flex-col lg:flex-row">
          <div className="flex relative p-4 sm:p-6 pb-8 lg:pb-4 lg:pt-11 lg:pl-20 lg:h-[640px] bg-[#F9F9F9] lg:rounded-br-[60px] sm:items-center flex-col sm:flex-row lg:flex-col lg:items-start lg:max-w-[55%]">
            <div data-aos="fade-up" className="sm:max-w-[70%] mr-4 mb-4">
              <h1 className={headingStyles}>Amazing Work Place</h1>
              <p className={`mt-2 lg:mt-4 ${paraStyles}`}>
                Work with like-minded, solution-focused, innovative folks in an
                organisation certified 'Great Place to Work' 2 years in a row,
                2022-2023 & 2023-2024.
              </p>
            </div>
            <Picture
              image="/assets/images/careers/greatplace"
              imageAlt="greatPlace"
              imageStyle="max-h-[140px] max-w-[90px] sm:max-h-[160px] sm:max-w-[105px] lg:min-h-[220px] lg:min-w-[145px] mt-6 sm:mt-0 lg:mt-12 ml-0 sm:ml-[84px] lg:ml-0"
            />
            <Picture
              image="/assets/images/careers/workplace"
              imageAlt="workplace"
              imageStyle="lg:rounded-[80px_0px_0px_60px] hidden lg:block lg:absolute -top-20 -right-[90%] w-full h-full"
            />
          </div>
          <Picture
            image="/assets/images/careers/workplace"
            imageAlt="workplace"
            imageStyle="lg:rounded-[80px_0px_0px_60px] lg:hidden"
          />
        </section>

        <section className="bg-[#F9F6EC] pt-6 lg:pt-[60px] pb-8 sm:py-10 lg:pb-[68px] sm:py-10 px-4 sm:px-[70px] lg:px-20 mt-[28px] sm:mt-[60px] lg:mt-[140px]">
          <div className="flex flex-col sm:items-center">
            <h1 data-aos="fade-up" className={headingStyles}>
              Our Solutions
            </h1>
            <p
              data-aos="fade-up"
              className={`sm:text-center mt-2 lg:mt-4 ${paraStyles} sm:max-w-xl lg:max-w-2xl`}
            >
              DeHaat provides end-to-end agricultural solutions to farmers,
              including access to high-quality products, services, and market
              linkages, to improve their productivity and profitability.
            </p>
          </div>

          <div className="grid gap-5 sm:gap-6 lg:gap-x-5 lg:gap-y-[28px] sm:grid-cols-2 lg:grid-cols-4 grid-cols-1 mt-[34px] sm:mt-12 lg:mt-[60px]">
            {solutionsList.map(({ image, heading, desc }) => (
              <SolutionBlock
                key={heading}
                image={image}
                heading={heading}
                desc={desc}
              />
            ))}
          </div>
        </section>

        <section className="mt-[28px] sm:mt-[60px] lg:mt-[143px] lg:pb-[68px] relative pb-6 sm:pb-10 lg:pb-[112px]">
          <div className="px-4 sm:px-0">
            <div className="flex flex-col sm:items-center">
              <h1 data-aos="fade-up" className={headingStyles}>
                Work Culture
              </h1>
              <p
                data-aos="fade-up"
                className={`sm:text-center mt-2 lg:mt-4 ${paraStyles} sm:max-w-2xl lg:max-w-5xl`}
              >
                Positive, supportive and dynamic environment where you will feel
                valued and motivated to do the best work. Fostering
                Intrapreneurship, open communication, collaboration, and a sense
                of shared purpose, which in turn can lead to increased job
                productivity that will suffice the organisational goals.
              </p>
            </div>
            <Swiper
              slidesPerView={1}
              spaceBetween={30}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                // 768: {

                1024: {
                  slidesPerView: 4,
                  spaceBetween: 50,
                },
              }}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              modules={[Autoplay, Navigation, Pagination]}
              className="w-[95%] h-[350px] sm:px-[36px] lg:px-20 mt-5 lg:mt-[103px] sm:mt-11 relative"
            >
              {workCultureImages.map(({ image, alt }, index) => (
                <SwiperSlide key={index} className="">
                  <div className="">
                    <Picture
                      className="rounded-2xl w-full object-cover h-[300px]"
                      image={image}
                      imageAlt={alt}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className="h-[140px] sm:h-[180px] lg:h-[226px] bg-primary-110 -z-10 absolute bottom-0 w-full" />
        </section>

        <section className="mt-10 sm:mt-[60px] lg:mt-[177px] px-4 sm:px-0">
          <div className="flex flex-col sm:items-center">
            <h1 data-aos="fade-up" className={headingStyles}>
              Benefits of Working
            </h1>
            <p
              data-aos="fade-up"
              className={`sm:text-center mt-2 lg:mt-4 ${paraStyles} sm:max-w-2xl`}
            >
              Joining DeHaat provides numerous benefits such as personal growth,
              health benefits, and opportunities for professional development,
              ultimately leading to a fulfilling and rewarding career.
            </p>
          </div>
          <div className="grid lg:grid-cols-2 grid-cols-1 sm:mt-12 lg:mt-20 mt-6 sm:mt-12 gap-8 sm:px-6 lg:px-20">
            {workingBenefits.map(({ image, heading, desc }) => (
              <div
                className="flex gap-2 sm:gap-5 sm:border-none border rounded-2xl py-4 px-2 sm:p-0 border-neutral-30"
                key={heading}
                data-aos="fade-left"
                data-aos-duration="500"
                data-aos-offset="200"
              >
                <div className="h-16 sm:h-[70px] lg:h-[88px] aspect-square bg-primary-10 shrink-0 flex justify-center items-center rounded-2xl">
                  <Picture
                    imageStyle="aspect-sqaure w-10 sm:w-12 lg:w-[60px]"
                    image={image}
                    imageAlt={heading}
                  />
                </div>
                <div>
                  <h5 className="text-neutral-90 text-lg lg:text-xl font-semibold lg:leading-[28px]">
                    {heading}
                  </h5>
                  <p className="mt-1 lg:mt-2 text-neutral-80 leading-[28px] sm:leading-[26px] lg:leading-[28px]">
                    {desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-[#F9F6EC] mt-10 sm:mt-[60px] lg:mt-[144px] pt-6 sm:pt-10 lg:pt-[60px] px-4 sm:px-6 lg:px-[100px] pb-6 sm:pb-10 lg:pb-[112px]">
          <h1 data-aos="fade-up" className={`sm:text-center ${headingStyles}`}>
            Our Testimonial
          </h1>

          <Testimonials />
        </section>

        <section className="mt-10 sm:mt-[60px] lg:mt-[100px] px-4 sm:px-0 pb-10 sm:pb-[60px] lg:pb-[140px]">
          <div className="flex flex-col sm:items-center">
            <h1 data-aos="fade-up" className={headingStyles}>
              Founders
            </h1>
            <p
              data-aos="fade-up"
              className={`sm:text-center mt-2 lg:mt-4 ${paraStyles} sm:max-w-xl lg:max-w-2xl`}
            >
              Alumni of top Indian institutes like IITs and IIMs came together
              to create India's Next Agri-revolution
            </p>
          </div>
          <div className="sm:px-5 lg:px-[60px] mt-6 sm:mt-12 lg:mt-[99px]">
            <Slider
              slidesToShowMobile={1}
              slidesToShowTablet={2}
              slidesToShowDesktop={4}
              containerStyles="sm:gap-10 lg:gap-6 items-center"
            >
              {founders.map(
                ({ image, name, designation, linkedin_link, twitter_link }) => (
                  <div
                    data-aos="flip-right"
                    data-aos-offset="200"
                    className="flex flex-col justify-center items-center sm:block"
                    key={name}
                  >
                    <Picture
                      image={image}
                      imageAlt={name}
                      imageStyle="h-48 lg:h-[259px] rounded-lg"
                    />
                    <h2 className="font-bold text-lg lg:text-xl mt-4 mr-0 sm:mr-6">
                      {name}
                    </h2>
                    <p className="font-medium text-lg mt-1 lg:mt-2 text-neutral-60 text-center sm:text-left">
                      {designation}
                    </p>
                    <div className="flex gap-3 mt-4">
                      <Link
                        className="h-8 w-8 border border-neutral-30 rounded-full flex items-center justify-center"
                        href={twitter_link}
                        target="_blank"
                      >
                        <TwitterIcon
                          className="fill-neutral-70"
                          height="17"
                          width="16"
                        />
                      </Link>
                      <Link
                        className="h-8 w-8 border border-neutral-30 rounded-full flex items-center justify-center"
                        href={linkedin_link}
                        target="_blank"
                      >
                        <LinkedinGreyIcon />
                      </Link>
                    </div>
                  </div>
                )
              )}
            </Slider>
          </div>
        </section>

        <section className="bg-primary-110 py-8 sm:pt-[26px] sm:pb-10 lg:py-[77px] grid sm:grid-cols-2 lg:grid-cols-4 grid-cols-1 justify-items-center gap-y-16">
          {dehaatNumbers.map(({ value, title }) => (
            <div className="flex flex-col items-center" key={title}>
              <h3 className="font-bold text-[40px] lg:text-[48px] text-white">
                {value}
              </h3>
              <p className="lg:text-xl mt-2 text-neutral-10 font-medium">
                {title}
              </p>
            </div>
          ))}
        </section>

        <section className="mt-10 sm:mt-[60px] lg:mt-[140px] px-4 sm:px-0 pb-6 sm:pb-10 lg:pb-[112px]">
          <div className="flex flex-col sm:items-center">
            <h1 data-aos="fade-up" className={headingStyles}>
              Life at <span className="text-primary-100">DeHaat</span>
            </h1>
            <p
              data-aos="fade-up"
              className={`sm:text-center mt-2 lg:mt-4 ${paraStyles} sm:max-w-xl lg:max-w-2xl`}
            >
              We at DeHaat believe in fostering a sense of inclusivity,
              promoting team bonding, and creating a positive and friendly work
              culture. We celebrate every occasion together sharing happiness as
              ONE FAMILY!
            </p>
          </div>
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 20,
              },

              1024: {
                slidesPerView: 3,
                spaceBetween: 50,
              },
            }}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay, Pagination]}
            className="mt-6 sm:mt-12 lg:mt-[72px] sm:px-6 lg:px-[100px] w-[95%] h-[350px]"
          >
            {dehaatLifeImages.map(({ image, alt }, index) => (
              <SwiperSlide key={index} className="">
                <Picture
                  className="rounded-2xl object-cover h-[300px]"
                  image={image}
                  imageAlt={alt}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </section>
      </main>
      <Footer />
    </>
  )
}

export default CareersPage
